module.exports = __webpack_public_path__ + "static/media/falcon-torch-carrying-case-3.1ce5a14a.jpg";